// @flow
import * as React from 'react';

const useMount = <T>(cb: () => T): T => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useEffect(() => cb(), []);
};

export default useMount;
